module.exports = __webpack_public_path__ + "img/imagem-boleto.27a1aa45.png";